<template>
  <div>
    <Collapse accordion simple v-model="currentTab">
      <Panel name="detail">
        吊车详情
        <div slot="content">
          <Form :model="crane" :label-width="120">
            <FormItem label="车型">
              <Input v-model="crane.name" placeholder="车型" />
            </FormItem>
            <FormItem label="品牌">
              <Select v-model="crane.brandId" filterable>
                <Option v-for="item in brands" :key="item.id" :value="item.id">{{item.name}}</Option>
              </Select>
            </FormItem>
            <FormItem label="最大起重量">
              <Input v-model="crane.max_weight" placeholder="最大起重量" />
            </FormItem>
            <FormItem label="吊车介绍">
              <Input v-model="crane.description" type="textarea" :rows="4" placeholder="吊车介绍" />
            </FormItem>
            <FormItem label="吊车图片">
              <div class="upload-container">
                <Upload
                  name="licence"
                  :show-upload-list="false"
                  :on-success="handleSuccess"
                  :format="['jpg','jpeg','png']"
                  :max-size="5120"
                  :on-format-error="handleFormatError"
                  :on-exceeded-size="handleMaxSize"
                  :before-upload="handleBeforeUpload"
                  type="drag"
                  :action="uploadUrl"
                  style="display: inline-block;width:128px;">
                  <div style="width: 128px;height:128px;line-height: 128px;">
                      <Icon type="ios-camera" size="20"></Icon>
                  </div>
                </Upload>

                <div class="upload-list" v-for="(item, index) in crane.images" :key="index">
                  <div class="upload-item" style="position: relative;">
                    <Icon type="ios-trash" class="remove-icon" @click="removeImage(index)" />
                    <img class="image-item" :src="item" alt="" />
                  </div>
                </div>
              </div>
            </FormItem>
            <FormItem label="吊车详情">
              <div class="upload-container">
                <Upload
                  name="licence"
                  :show-upload-list="false"
                  :on-success="handleDetailSuccess"
                  :format="['jpg','jpeg','png']"
                  :max-size="5120"
                  :on-format-error="handleFormatError"
                  :on-exceeded-size="handleMaxSize"
                  :before-upload="handleDetailBeforeUpload"
                  type="drag"
                  :action="uploadUrl"
                  style="display: inline-block;width:128px;">
                  <div style="width: 128px;height:128px;line-height: 128px;">
                      <Icon type="ios-camera" size="20"></Icon>
                  </div>
                </Upload>

                <div class="upload-list" v-for="(item, index) in crane.detail" :key="index">
                  <div class="upload-item" style="position: relative;">
                    <Icon type="ios-trash" class="remove-icon" @click="removeDetailImage(index)" />
                    <img class="image-item" :src="item" alt="" />
                  </div>
                </div>
              </div>
            </FormItem>
            <FormItem>
              <Button type="primary" @click="addCrane" size="small">保存</Button>
            </FormItem>
          </Form>
        </div>
      </Panel>
      <Panel name="weight">
        配重详情
        <div slot="content">
          <Alert type="error" v-if="!crane.id">请先创建吊车</Alert>
          <div v-else>
            <Tabs closable :animated="false" v-model="currentWeight" type="card" @on-tab-remove="removeTab">
              <div slot="extra">
                <Button type="primary" size="small" @click.prevent="addNewWeight">添加配重信息</Button>
                <Button style="margin-left: 4px;" v-if="primaryData.length > 0" type="primary" size="small" @click="saveWeight">保存配重信息</Button>
              </div>
              <TabPane closable v-for="item in crane.ways" :key="item.id" :label="(item.out_weight ? '超起' : '') + '配重' + item.crane_weight + 't' + ((item.other_weight != 0) ? ((item.leg_type == 2 ? '副臂' : '塔况') + '配重' + item.other_weight + 't') : '')" :name="item.id + ''">
                <Form :model="craneWeight" :label-width="120">
                  <FormItem label="调臂组合方式">
                    <Select v-model="craneWeight.leg_type" @on-change="changeLetType">
                      <Option :value="1">主臂</Option>
                      <Option :value="2">主臂+副臂</Option>
                      <Option :value="3">主臂+塔况</Option>
                    </Select>
                  </FormItem>
                  <FormItem label="配重">
                    <Input v-model="craneWeight.weight" placeholder="配重，单位为吨" />
                  </FormItem>
                  <FormItem label="后移">
                    <Input v-model="craneWeight.back_length" placeholder="配重后移" />
                  </FormItem>
                  <FormItem label="是否超起">
                    <Checkbox v-model="craneWeight.out_weight"></Checkbox>
                  </FormItem>
                  <FormItem :label="otherWeightLabel" v-if="craneWeight.leg_type != 1">
                    <Input v-model="craneWeight.other_weight" :placeholder="otherWeightLabel" />
                  </FormItem>
                  <FormItem label="工作范围">
                    <Input v-model="craneWeight.extent" placeholder="工作范围" />
                  </FormItem>
                  <FormItem label="支腿方式">
                    <Input v-model="craneWeight.leg_way" placeholder="支腿方式" />
                  </FormItem>
                  <FormItem label="性能参数">
                    <div class="primary-container" v-if="craneWeight.leg_type == 1">
                      <div class="excel-container">
                        <Excel @changeFile="changePrimary">
                          <div slot="button" class="choose-file"><Icon type="ios-camera" size="20"></Icon></div>
                        </Excel>
                      </div>
                      <div ref="testTable" style="height: 60vh; overflow-y: auto; width: 550px;" v-if="primaryData.length > 0">
                        <plx-table-grid :data="primaryData" fixed-columns-roll :use-virtual="true" :row-height="40" :excess-rows="30" :fit="true" :pagination-show="false">
                          <plx-table-column
                            v-for="(item, index) in primaryColumn"
                            :key="index"
                            :resizable="true"
                            :prop="item.prop"
                            :label="item.label"
                            :width="item.width"/>
                        </plx-table-grid>
                      </div>
                    </div>
                    <div class="minor-container" v-if="craneWeight.leg_type == 2">
                      <div class="excel-container">
                        <Excel @changeFile="changePrimary" :type="2">
                          <div slot="button" class="choose-file"><Icon type="ios-camera" size="20"></Icon></div>
                        </Excel>
                      </div>
                      <div style="height: 60vh; width: 750px;" v-if="primaryData.length > 0">
                        <plx-table-grid :datas="primaryData" fixed-columns-roll :use-virtual="true" :row-height="40" :excess-rows="30" :fit="true" :pagination-show="false">
                          <plx-table-column
                            v-for="(item, index) in minorColumn"
                            :key="index"
                            :resizable="true"
                            :prop="item.key"
                            :label="item.title"
                            :width="item.width"/>
                        </plx-table-grid>
                      </div>
                    </div>
                    <div class="other-container" v-if="craneWeight.leg_type == 3">
                      <Form inline :label-width="240" style="margin-bottom: 12px;">
                        <FormItem>
                          <Input type="text" v-model="armInfo.primary_length" placeholder="主臂长度" />
                        </FormItem>
                        <FormItem>
                          <Input type="text" v-model="armInfo.minor_length" placeholder="横臂长度" />
                        </FormItem>
                        <FormItem>
                          <Input type="text" v-model="armInfo.way" placeholder="组合方式" />
                        </FormItem>
                        <FormItem>
                          <Input type="text" v-model="armInfo.radius" placeholder="作业半径" />
                        </FormItem>
                        <FormItem>
                          <Input type="text" v-model="armInfo.weight" placeholder="额定起重量(吨/t)" />
                        </FormItem>
                        <FormItem>
                          <Button size="small" type="primary" @click="addArm">添加</Button>
                        </FormItem>
                      </Form>
                      <div style="height: 100vh;" v-if="primaryData.length > 0">
                        <pl-table :datas="primaryData"></pl-table>
                      </div>
                      <Table size="small" v-if="primaryData.length > 0" border :columns="armColumn" :data="primaryData">
                        <template slot="operator" slot-scope="{ index }">
                          <Button type="error" size="small" @click="removeMinor(index)">删除</Button>
                        </template>
                      </Table>
                    </div>
                  </FormItem>
                </Form>
              </TabPane>
            </Tabs>
          </div>
        </div>
      </Panel>
    </Collapse>
  </div>
</template>

<script>
import api from '@/api';
import { base } from '@/config';
import Excel from './ImportExcel.vue';

const primaryColumn = [
  {label: '臂长', prop: 'primary_length', width: 100},
  {label: '作业半径', prop: 'radius', width: 100},
  {label: '组合方式', prop: 'way', width: 100},
  {label: '额定起重量(吨/t)', prop: 'weight', width: 200}
];

const minorColumn = [
  {title: '主臂长', key: 'primary_length', width: 100},
  {title: '副臂长度', key: 'minor_length', width: 100},
  {title: '副臂角度', key: 'angle', width: 100},
  {title: '作业半径', key: 'radius', width: 100},
  {title: '组合方式', key: 'way', width: 100},
  {title: '额定起重量(吨/t)', key: 'weight', width: 200},
];

const armColumn = [
  {title: '主臂长', key: 'primary_length'},
  {title: '塔臂长度', key: 'minor_length'},
  {title: '作业半径', key: 'radius'},
  {title: '组合方式', key: 'way'},
  {title: '额定起重量(吨/t)', key: 'weight'},
  {title: '操作', slot: 'operator'}
];

export default {
  computed: {
    otherWeightLabel() {
      if (this.craneWeight.leg_type == 2) {
        return '副臂配重';
      } else if (this.craneWeight.leg_type == 3) {
        return '塔况配重';
      }

      return '';
    }
  },
  data() {
    return {
      currentTab: 'detail',
      crane: {
        id: 0,
        name: '',
        brandId: '',
        description: '',
        images: [],
        detail: [],
        max_weight: '',
        ways: []
      },
      craneWeight: {
        leg_type: 1,
        weight: '',
        other_weight: 0,
        out_weight: false,
        leg_way: '支腿全伸',
        extent: '360'
      },
      minorInfo: {
        primary_length: '',
        minor_length: '',
        angle: '',
        radius: '',
        way: '',
        weight: ''
      },
      armInfo: {
        primary_length: '',
        minor_length: '',
        radius: '',
        way: '',
        weight: ''
      },
      primaryColumn,
      minorColumn,
      armColumn,
      primaryData: [],
      uploadUrl: base + '/api/setting/upload',
      brands: [],
      currentWeight: ''
    }
  },
  components: {
    Excel
  },
  methods: {
    saveWeight() {
      let wayData = this.primaryData.map(v => {
        delete v['_XID'];
        return v;
      });

      if (this.currentWeight == -1) {
        api.post(api.url('craneWeight', this.$route.params.id), {
          leg_type: this.craneWeight.leg_type,
          weight: this.craneWeight.weight,
          other_weight: this.craneWeight.other_weight,
          out_weight: this.craneWeight.out_weight,
          back_length: this.craneWeight.back_length,
          leg_way: this.craneWeight.leg_way,
          extent: this.craneWeight.extent,
          ways: wayData,
        }).then(res => {
          this.crane.ways[this.crane.ways.length - 1] = {
            id: res.id,
            leg_type: this.craneWeight.leg_type,
            crane_weight: this.craneWeight.weight,
            leg_way: this.craneWeight.leg_way,
            other_weight: this.craneWeight.other_weight,
            out_weight: this.craneWeight.out_weight,
            back_length: this.craneWeight.back_length,
            extent: this.craneWeight.extent,
            ways: [],
          };
          localforage.setItem(`craneWeight_${res.id}`, JSON.stringify(wayData));
          this.$Message.success('添加配重成功');
          this.addNewWeight();
        }).catch(err => {
          this.$Message.error(err);
        })
      } else {
        api.put(api.url('craneWeightUpdate', this.crane.id, this.currentWeight), {
          leg_type: this.craneWeight.leg_type,
          weight: this.craneWeight.weight,
          other_weight: this.craneWeight.other_weight,
          out_weight: this.craneWeight.out_weight,
          back_length: this.craneWeight.back_length,
          leg_way: this.craneWeight.leg_way,
          extent: this.craneWeight.extent,
          ways: wayData,
        }).then(res => {
          this.crane.ways[this.crane.ways.length - 1] = {
            id: res.id,
            leg_type: this.craneWeight.leg_type,
            weight: this.craneWeight.weight,
            other_weight: this.craneWeight.other_weight,
            out_weight: this.craneWeight.out_weight,
            back_length: this.craneWeight.back_length,
            leg_way: this.craneWeight.leg_way,
            extent: this.craneWeight.extent,
            ways: [],
          };
          localforage.setItem(`craneWeight_${res.id}`, JSON.stringify(wayData));
          this.$Message.success('修改配重成功');
        }).catch(err => {
          this.$Message.error(err);
        })
      }
    },
    removeTab(name) {
      let index = -1;
      this.crane.ways.forEach((v, k) => {
        if (v.id == name) {
          index = k;
        }
      });

      if (index != -1 && name != -1) {
        this.crane.ways.splice(index, 1)
        api.delete(api.url('weightRemove', name))
      }
    },
    addNewWeight() {
      if (this.crane.ways.filter(v => v.id == -1).length !== 0) {
        this.currentWeight = '-1';
        return;
      }

      this.crane.ways.push({
        id: -1,
        leg_type: 1,
        crane_weight: '',
        other_weight: 0,
        out_weight: false,
        leg_way: '支腿全伸',
        extent: '360',
        ways: []
      });

      this.craneWeight = {
        leg_type: 1,
        crane_weight: '',
        other_weight: 0,
        out_weight: false,
        leg_way: '支腿全伸',
        extent: '360',
      };
      this.primaryData = [];
      this.currentWeight = '-1';
    },
    removeMinor(v) {
      this.primaryData.splice(v, 1)
    },
    addArm() {
      this.primaryData = [this.armInfo].concat(this.primaryData);
      this.armInfo = {
        primary_length: this.armInfo.primary_length,
        minor_length: this.armInfo.minor_length,
        radius: '',
        way: this.armInfo.way,
        weight: ''
      }
    },
    addMinor() {
      this.primaryData = [this.minorInfo].concat(this.primaryData);
      this.minorInfo = {
        primary_length: this.minorInfo.primary_length,
        minor_length: this.minorInfo.minor_length,
        angle: this.minorInfo.angle,
        radius: '',
        way: this.minorInfo.way,
        weight: ''
      }
    },
    changePrimary(data) {
      this.primaryData = data;
    },
    handleFormatError() {
      this.$Message.error('不支持的文件格式');
    },
    handleMaxSize() {
      this.$Message.error('文件太大了');
    },
    handleSuccess(res) {
      if (res.code == 0) {
        this.crane.images.push(res.data.url);
      }
    },
    handleBeforeUpload() {
      if (this.crane.images.length < 5) {
        return true;
      }

      this.$Message.error('最多只能上传5张吊车图片');
      return false;
    },
    removeImage(index) {
      this.crane.images.splice(index, 1)
    },
    handleDetailSuccess(res) {
      if (res.code == 0) {
        this.crane.detail.push(res.data.url);
      }
    },
    handleDetailBeforeUpload() {
      if (this.crane.detail.length < 12) {
        return true;
      }

      this.$Message.error('最多只能上传5张吊车图片');
      return false;
    },
    removeDetailImage(index) {
      this.crane.detail.splice(index, 1)
    },
    addCrane() {
      api.put(api.url('craneUpdate', this.crane.id), {
        name: this.crane.name,
        brand_id: this.crane.brandId,
        description: this.crane.description,
        images: this.crane.images,
        detail: this.crane.detail,
        max_weight: this.crane.max_weight,
      }).then(res => {
        this.$Message.success('吊车修改成功');
        this.crane.id = res.id;
      }).catch(err => {
        this.$Message.error(err);
      })
    },
    changeLetType() {
      this.primaryData = [];
    }
  },
  mounted() {
    api.get(api.url('setting')).then(res => {
      this.brands = res.brands;
    }).catch(err => {
      this.$Message.error(err)
    });

    api.get(api.url('craneUpdate', this.$route.params.id)).then(res => {
      if (res.ways.length > 0) {
        let item = res.ways[0];
        this.craneWeight = {
          id: item.id,
          leg_type: item.leg_type,
          weight: item.crane_weight,
          leg_way: item.leg_way,
          extent: item.extent,
          other_weight: item.other_weight,
          out_weight: item.out_weight,
        };

        this.primaryData = item.ways;
      }

      res.ways = res.ways.map(v => {
        localforage.setItem(`craneWeight_${v.id}`, JSON.stringify(v.ways));
        v.ways = [];
        return v;
      });

      this.crane = res;
    }).catch(err => {
      // eslint-disable-next-line
      console.log(err)
      this.$Message.error(err);
    });
  },
  beforeDestroy() {
    localStorage.clear();
  },
  watch: {
    currentWeight(name) {
      let item = null;
      this.crane.ways.forEach(v => {
        if (v.id == name) {
          item = v;
        }
      });

      if (item === null) {
        return;
      }

      this.craneWeight = {
        leg_type: item.leg_type,
        weight: item.crane_weight,
        leg_way: item.leg_way,
        extent: item.extent,
        other_weight: item.other_weight,
        out_weight: item.out_weight,
      };

      const that = this;
      localforage.getItem(`craneWeight_${name}`).then((val) => {
        that.primaryData = JSON.parse(val)

        console.log(that, JSON.parse(val), '======')
      }).catch((err) => {
        console.log(err, '======')
      })
    },
  }
}
</script>

<style>
  .ivu-upload-drag { width: 128px; }
  .upload-container { display: flex; }
  .upload-list { display: flex; }
  .upload-item { margin-left: 12px; width: 128px; height: 128px; border: 1px dashed #dcdee2; display: flex; align-items: center; justify-content: center; border-radius: 4px; }
  .image-item { width: 128px; max-height: 128px; margin-top: 0; }
  .remove-icon { position: absolute; right: 4px; top: 4px; color: #ed4014; font-size: 24px; cursor: pointer; }

  .excel-container { width: 128px; height: 128px; margin-bottom: 12px; }
  .choose-file { width: 128px; height: 128px; border: 1px dashed #dcdee2; border-radius: 4px; display: flex; justify-content: center; align-items: center; cursor: pointer; }
</style>
